"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mustContainInteger = void 0;
const is_integer_1 = require("../../functions/is-integer/is-integer");
const is_measure_1 = require("../../functions/is-measure/is-measure");
const validation_1 = require("../validation/validation");
/**
 * @summary Creates a `Validation` for integer fields.
 *
 * Creates a `Validation` for integer fields. If the fields contain any value, validates that the value is an
 * integer. It does not matter for this validation if the given value is a number or string type.
 *
 * Note: This validation will also succeed on empty values. If a value must be given, use the `isRequired` validation.
 *
 * @param {string | undefined} message
 * @returns {Validation}
 *
 * @see Validation
 */
function mustContainInteger(message) {
    return (0, validation_1.validation)(message ?? 'The given value must be an integer.', (value) => {
        const check = (0, is_measure_1.isMeasure)(value) ? value.value : value;
        if (typeof check === 'string') {
            return !check.trim() || (0, is_integer_1.isInteger)(check);
        }
        return check == null || Number.isInteger(check);
    });
}
exports.mustContainInteger = mustContainInteger;
